export default __webpack_public_path__ + "static/media/deal.bc046f62.png";